import { useEffect } from 'react'
import { useFormikContext } from 'formik'

import { updateSignature } from '../../../../utils/signature'
import { useFormikFieldValue } from '../../../Formik'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_FROM,
  EMAIL_CREATION_FORM_FIELD_NAME_MESSAGE,
  EMAIL_CREATION_FORM_FIELD_NAME_SIGNATURE,
} from '../EmailCreationForm.constants'

export function useSignature() {
  const { values } = useFormikContext()

  const { [EMAIL_CREATION_FORM_FIELD_NAME_FROM]: account } = values

  const [message, setMessage] = useFormikFieldValue(
    EMAIL_CREATION_FORM_FIELD_NAME_MESSAGE
  )

  const [signature, setSignature] = useFormikFieldValue(
    EMAIL_CREATION_FORM_FIELD_NAME_SIGNATURE
  )

  useEffect(() => {
    const [nextMessage, signatureHTML] = updateSignature(message, account)

    setMessage(nextMessage)
    setSignature(signatureHTML)
  }, [account])

  return { currentSignature: signature }
}
